import { Money } from '../types';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';

export interface Meal {
	id: string;
	segmentsId: string[];
	name: string;
	imageURL: string;
	icon?: string;
	price: Money;
	weight?: number;
	allergens: string[];
	category: string;
	description: string;
	allowedPassengers: string[];
	canBeAdded: boolean;
	allowedSegments?: string[][];
	isRecommend?: boolean;
	rfics: string;
	type: OrderAdditionalServiceGdsServiceServiceType;
}

export interface MealConsumer {
	id: string;
	name: string;
	isIdentified?: boolean;
}

export interface MealCounter {
	passenger: MealConsumer;
	count: number;
	confirmedCount: number;
	minAvailable?: number;
	maxAvailable?: number;
}

export enum MealViewMode {
	select,
	confirmed
}
